import {testIdProps} from '@github-ui/test-id-props'
import {XCircleFillIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useFilterQuery, useInput} from './context'

export const ClearButton = () => {
  const {suspendFocus} = useInput()
  const {rawFilterRef, clearFilter} = useFilterQuery()

  return (
    <IconButton
      {...testIdProps('filter-clear-query')}
      as="button"
      aria-label="Clear Filter"
      onMouseDown={e => suspendFocus(e.currentTarget)}
      onKeyDown={e => suspendFocus(e.currentTarget)}
      onClick={() => clearFilter()}
      icon={XCircleFillIcon}
      variant="invisible"
      size="small"
      sx={{
        display: rawFilterRef?.current.length === 0 ? 'none' : 'flex',
        ':hover': {
          bg: 'transparent',
          color: 'fg.subtle',
        },
      }}
    />
  )
}

try{ ClearButton.displayName ||= 'ClearButton' } catch {}